import styled from 'styled-components';

export const ReturnOrdersWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const ReturnCardContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const ReturnItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const Title = styled.h4`
  text-align: center;
  font-weight: 400;
`;

export const Header = styled.div`
  cursor: pointer;
  position: relative;
  min-height: 40px;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 60px 16px 20px;
`;

export const ActionBar = styled.div`
  display: flex;
  gap: 20px;
`;

export const ActionButton = styled.button`
  text-decoration: none;
  border: 0 none;
  background: transparent;
  padding: 0;
`;

export const DetailFieldTitle = styled.div`
  font-weight: bold;
`;

export const DetailFieldValue = styled.div`
  text-transform: capitalize;
`;
